"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromoStyled = exports.PromoLogoStyled = exports.StyledBox = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _const = require("@dbi-tools/ui-kit/lib/const");

var _helpers = require("../../helpers");

var _styled = require("../../styled");

var _headerTitles = require("../header-titles/header-titles.styled");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n            margin: 0 8px;\n          "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n            padding: 15px 23px;\n          "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: ", ";\n  min-height: ", "px;\n  margin: 0 15px;\n  ", "\n\n  ", " {\n    p {\n      ", ";\n      margin-top: ", ";\n    }\n  }\n\n  ", " {\n    ", "\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    position: static;\n    height: 50px;\n    width: 50px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    margin: 0 -15px;\n    padding: 15px;\n\n    ", " {\n      margin: 0 10px;\n    }\n\n    ", " {\n      color: ", ";\n    }\n    ", " {\n      color: ", ";\n    }\n    ", " {\n      color: ", ";\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", ";\n  & > img {\n    position: absolute;\n    top: 0;\n    height: 100%;\n    width: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledBox = (0, _uiKit.styled)(_uiKit.Box)(_templateObject(), function (_ref) {
  var $theme = _ref.theme.$theme;
  return $theme && (0, _helpers.getTheme)($theme);
});
exports.StyledBox = StyledBox;

var bgStyles = function bgStyles(colorContrast) {
  return (0, _uiKit.css)(_templateObject2(), _const.GridBreakpointsMediaDown.sm, _headerTitles.OverlineStyled, colorContrast, _headerTitles.HeadlineStyled, colorContrast, _headerTitles.DescriptionStyled, colorContrast);
};

var PromoLogoStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject3(), _uiKit.LoadingBlockStyled);
exports.PromoLogoStyled = PromoLogoStyled;
var PromoStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject4(), function (_ref2) {
  var alignItems = _ref2.alignItems;
  return alignItems;
}, function (_ref3) {
  var height = _ref3.height;
  return height;
}, function (_ref4) {
  var isBackgroundOn = _ref4.isBackgroundOn,
      colorContrast = _ref4.colorContrast;
  return isBackgroundOn && bgStyles(colorContrast);
}, _headerTitles.DescriptionStyled, _styled.Line3Styles, function (_ref5) {
  var isLargeBlock = _ref5.isLargeBlock;
  return isLargeBlock ? '15px' : '5px';
}, _const.GridBreakpointsMediaUp.lg, function (_ref6) {
  var isBackgroundOn = _ref6.isBackgroundOn;
  return isBackgroundOn ? (0, _uiKit.css)(_templateObject5()) : (0, _uiKit.css)(_templateObject6());
});
exports.PromoStyled = PromoStyled;